module.exports = "<p>\n  declaration-receipt-upload works!\n</p>\n"